import { render, staticRenderFns } from "./Step1SalesStrategy.vue?vue&type=template&id=319964f9&scoped=true"
import script from "./Step1SalesStrategy.vue?vue&type=script&lang=js"
export * from "./Step1SalesStrategy.vue?vue&type=script&lang=js"
import style0 from "./Step1SalesStrategy.vue?vue&type=style&index=0&id=319964f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319964f9",
  null
  
)

export default component.exports